import "./TimeSeriesPeriodComponent.scss";
import template from "./TimeSeriesPeriodComponent.html";
import {IComponentOptions} from "angular";
import {TimeSeriesPeriod, TimeSeriesPeriods} from "../types/TimeSeriesPeriod";
import {ReplaySubject} from "rxjs";
import {ComponentCallback} from "../../../types/AngularJS";

export const TimeSeriesPeriodComponent = "tfTimeSeriesPeriodSelect";

export function timeSeriesPeriodComponent(): IComponentOptions {
    return {
        template,
        bindings: {
            selected: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: TimeSeriesPeriodComponentController
    };
}

export class TimeSeriesPeriodComponentController {

    /** @input */
    public set selected(selected: TimeSeriesPeriod | null) {
        if (selected == null) {
            this.selected$.next(TimeSeriesPeriod.DAILY);
        } else {
            this.selected$.next(selected);
        }
    }

    public readonly selected$ = new ReplaySubject<TimeSeriesPeriod>(1);

    /** @output */
    public readonly onChange: ComponentCallback;

    public readonly periods = TimeSeriesPeriods;

    public updatePeriod(period: TimeSeriesPeriod) {
        this.onChange({period});
    }
}
